import { getFiGrowthBook } from '../../../../lib/growthbook';
import { FiCurrency } from '../../../../types';

export const KLARNA_BNPL_FLAG = 'klarna-bnpl';

/**
 * klarna installment checkout (pay in 4 / monthly financing) at the prepaid checkout.
 *
 * us-only, proxied by usd currency (klarna recurring is us-only and stripe won't surface it for
 * other billing countries anyway). internalTester exposure and staged rollout are handled by the
 * `klarna-bnpl` growthbook flag's targeting rules, not here. reading via getFeatureValue also
 * honors the fi_gb_ee_klarna-bnpl override cookie for per-browser QA.
 */
export function isKlarnaBnplEnabled(currency: FiCurrency): boolean {
  if (currency !== FiCurrency.USD) {
    return false;
  }
  return getFiGrowthBook().getFeatureValue(KLARNA_BNPL_FLAG, false);
}
